"use client"

import { useEffect } from "react"
import { useLogger, LogLevel } from "next-axiom"
import { usePathname } from "next/navigation"

export default function GlobalError({ error }) {
  const log = useLogger({ source: "global-error.jsx" })
  const pathname = usePathname()

  useEffect(() => {
    log.error(error)
  }, [error])

  log.logHttpRequest(
    LogLevel.error,
    error?.message,
    {
      host: window.location.href,
      path: pathname,
      statusCode: 500,
    },
    {
      error: error.name,
      cause: error.cause,
      stack: error.stack,
      digest: error.digest,
    },
  )

  return (
    <div
      className="flex min-h-screen items-center justify-center bg-gradient-to-br from-gray-100 to-gray-200 px-4 py-12"
      style={{ fontFamily: "ui-sans-serif, system-ui, sans-serif" }}
    >
      <div className="flex w-full max-w-lg flex-col items-center rounded-2xl bg-white p-10 shadow-2xl md:p-16">
        <div className="flex flex-col items-center">
          <span className="mb-4 select-none text-7xl font-extrabold text-rose-500 drop-shadow-sm">
            500
          </span>
          <p className="mb-8 gap-4 text-center text-lg text-muted-foreground">
            Something went wrong!
          </p>
        </div>
        <div className="mt-4 flex w-full flex-col justify-center gap-4 md:flex-row">
          <a
            href="/"
            className="w-full rounded-xl border border-gray-200 bg-gray-100 px-6 py-3 text-center text-lg font-medium text-gray-700 shadow transition hover:bg-gray-200"
          >
            Go Home
          </a>
          <a
            href={`/login?returnTo=${pathname}`}
            className="w-full rounded-xl bg-primary px-6 py-3 text-center text-lg font-semibold text-primary-foreground shadow transition hover:bg-primary/90"
          >
            Login
          </a>
        </div>
      </div>
    </div>
  )
}
